/** Shared call-control icons (start / hang-up), used by CallButton and Trigger. */

export function PhoneIcon() {
  return (
    <svg class="va-call-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M6.6 10.8a15.5 15.5 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.4 11.4 0 0 0 3.6.58 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.4 11.4 0 0 0 .58 3.6 1 1 0 0 1-.24 1z" />
    </svg>
  );
}

/**
 * Hang-up handset: a slim phone handset rotated 135° (the standard "end call"
 * glyph). Drawn thin so it doesn't read as a chunky blob at small button sizes.
 */
export function HangUpIcon() {
  return (
    <svg class="va-call-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 9.5c-3 0-5.9.5-8.4 1.5-.6.2-1 .8-1 1.5l.2 1.5c.1.6.6 1 1.2 1l2.6-.2c.6 0 1-.4 1.1-1l.2-1.4c1.3-.3 2.6-.4 3.9-.4s2.6.1 3.9.4l.2 1.4c.1.6.5 1 1.1 1l2.6.2c.6 0 1.1-.4 1.2-1l.2-1.5c0-.7-.4-1.3-1-1.5-2.5-1-5.4-1.5-8.4-1.5z" />
    </svg>
  );
}

/** Chevron pointing up — folded trigger's "expand" affordance. */
export function ChevronUpIcon() {
  return (
    <svg
      class="va-call-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path d="M6 15l6-6 6 6" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

/** Chevron pointing down — expanded panel's "collapse" affordance. */
export function ChevronDownIcon() {
  return (
    <svg
      class="va-call-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path d="M6 9l6 6 6-6" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
